// @ts-nocheck
import { useState } from "react";
import { dateToUsShortFormat } from "utils/helpers";
import { ReactComponent as AscIcon } from "images/sort_asc.svg";
import { ReactComponent as DescIcon } from "images/sort_desc.svg";

const SorterArrow = ({ sortOrder }) => {
  return sortOrder === "asc" ? <AscIcon /> : <DescIcon />;
};

export const SubtotalTable = ({ subtotalData, itemName }) => {
  const [sortIndex, setSortIndex] = useState(2);
  const [sortOrder, setSortOrder] = useState("asc");

  const labels = [
    {
      index: 2,
      text: itemName,
      align: "flex-start",
    },
    {
      index: 3,
      text: "Digital Clicks",
    },
    {
      index: 4,
      text: "Physical Clicks",
    },
    {
      index: 5,
      text: "Link Clicks",
    },
    {
      index: 6,
      text: "Total Clicks",
    },
    {
      index: 7,
      text: "Clicks Period",
    },
    {
      index: 9,
      text: "Digital Buttons",
    },
    {
      index: 10,
      text: "Physical Buttons",
    },
    {
      index: 11,
      text: "Total Buttons",
    },
  ];

  const sortedData = subtotalData?.sort((a, b) => {
    if (a[sortIndex] === null || b[sortIndex] === null) {
      return -1;
    }
    if (sortOrder === "asc") {
      return a[sortIndex] < b[sortIndex] ? -1 : 1;
    } else {
      return a[sortIndex] < b[sortIndex] ? 1 : -1;
    }
  });

  const handleSorterClick = (index) => {
    if (sortIndex === index) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortIndex(index);
      setSortOrder("asc");
    }
  };

  return (
    <>
      <h3 className="text-2xl font-bold text-gray-900">
        Digital and physical clicks and buttons.
      </h3>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y text-center divide-gray-200">
          <thead className="bg-gray-100">
            <tr>
              {labels.map((label) => {
                const isActive =
                  sortIndex === label.index ||
                  (label.index === 6 && sortIndex === 7);

                return (
                  <th
                    key={`${label.index}-${label.name}`}
                    scope="col"
                    className={[
                      // "flex flex-row justify-center items-center",
                      "px-2 py-3 text-left text-xs cursor-pointer font-medium tracking-wider",
                      isActive ? "text-gray-900" : "text-gray-500",
                    ]
                      .filter(Boolean)
                      .join(" ")}
                    onClick={() =>
                      handleSorterClick(label.index === 6 ? 7 : label.index)
                    }
                  >
                    <div
                      className={[
                        "flex flex-row items-center",
                        !label?.align
                          ? "justify-center"
                          : label.align,
                      ].join(", ")}
                    >
                      {label.text !== "Buttons" ? label.text : "Button holder"}
                      {isActive && <SorterArrow sortOrder={sortOrder} />}
                    </div>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {sortedData?.map((row, index) => (
              <tr
                className={
                  index % 2 === 0
                    ? "bg-white hover:bg-blue-100"
                    : "bg-gray-50  hover:bg-blue-200"
                }
                key={`${row[0]}-${row[1]}-${row[2]}`}
              >
                <td className="px-2 py-1 text-left text-xs text-gray-900">
                  {[row[2], row[1]].filter(Boolean).join(", ")}
                </td>
                <td className="px-2 py-1 whitespace-nowrap text-xs text-gray-900">
                  {row[3]}
                </td>
                <td className="px-2 py-1 whitespace-nowrap text-xs text-gray-900">
                  {row[4]}
                </td>
                <td className="px-2 py-1 whitespace-nowrap text-xs text-gray-900">
                  {row[5]}
                </td>
                <td className="px-2 py-1 whitespace-nowrap text-xs text-gray-900">
                  {row[6]}
                </td>
                <td className="px-2 py-1 whitespace-nowrap text-xs text-gray-900">
                  {!!row[7] &&
                    !!row[8] &&
                    `${dateToUsShortFormat(row[7])} - ${dateToUsShortFormat(
                      row[8]
                    )}`}
                </td>
                <td className="px-2 py-1 whitespace-nowrap text-xs text-gray-900">
                  {row[9]}
                </td>
                <td className="px-2 py-1 whitespace-nowrap text-sm text-gray-900">
                  {row[10]}
                </td>
                <td className="px-2 py-1 whitespace-nowrap text-sm text-gray-900">
                  {row[11]}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};
